module.exports = __webpack_public_path__ + "img/weather-cloudy.520d482f.png";